// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { JoHeader } from './jo-header';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class JoStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** String(7) key */
  id!: string;
  /** Boolean */
  isObsolete!: boolean;
  /** String(40) */
  name?: string;
  /** Inv FK joStatusId */
  joHeaders!: JoHeader[];
}

